
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import {unmountComponentAtNode} from 'react-dom';
import Select from 'react-select';
import Process from './imgs/process.gif';
import axios from 'axios';
import { getmessage,setpls,getpls } from './Dynamictable';
import Configdata from './Defaultdata';
import Search from './Search';
//import AutocompleteInput from './AutocompleteInput';
import Usersession from './Usersession';
import { incities } from './userdefaultdata';
import{ clearmain } from './clearmem';
import {reducearray,cnvrtdropdown} from './Defaulddbdata';
class Searchcriteria extends Component {
	constructor(props: any) {
   	super(props);
	this.state.togglecrit = false;
	this.state.slctrent = true;
	this.state.slctsale = false;
	this.state.slctlease = false;
	
	this.state.slctcity = false;
	this.state.slctstate = false;
	this.state.slcthome = true;
	this.state.slctowner = true;
	this.state.slctagent = false;
	this.state.slctland = false;
	this.state.locality =['hgg','hhjjj','yyu'];


    	//this.toggelcriteria = this.toggelcriteria.bind(this);
  	}
	state = {
        name: "SIIKAA",
        togglecrit: false,
        slctrent: true,
	slctsale: false,
        slctlease: false,
	slctlservice:false,
	slctcity:false,
	slctstate:false,
	slcthome:true,
	slctland:false,
	slctowner:true,
	slctagent:false,
	cityid:0,
	locality:[''],
        localityid:0,
        transcid:1,
        localslct:'Select locality', 
        ctlocality:[{ value: 0, label: 'Others' }],
        cities:[{ value: 0, label: 'Others' }]
    	};
       checkoptions(){
	let valid = true;
	if(this.state.cityid == 0){
		 valid = false;
		getmessage('Please select city','')
	}
	//else if(this.state.localityid == 0){
		// valid = false;
		//getmessage('Please select Locality','')
	//}
	return valid;

	}
	displaysearch(e: any){
		
		const element = <Search />
		ReactDOM.render(element, document.getElementById('container'));
		 const Pdivc = document.getElementById('profilediv') as HTMLElement;
		
		Pdivc.style.display = 'none';
		const homemain = document.getElementById('container') as HTMLElement;
		homemain.style.display = 'block';

		e.preventDefault()

	};
        searchproperty(e:any){
		if(this.checkoptions()){
		this.gotosearchprpty(true);
	 }
	 e.preventDefault()
	}
        gotosearchprpty(e:any){
        let criterias = Usersession.getSearchopts();
        const ctd = this.state.cityid; 
        const strcityid = ctd.toString();
	criterias["ctid"] = strcityid;
	let ppt = "1";
	
         if(!this.state.slcthome) 
	   ppt ="2";
	 criterias["localid"] = this.state.localityid.toString();
	   Usersession.setType(ppt);
		Usersession.setCityId(strcityid);
	criterias["trnstpid"]=this.state.transcid.toString();
        if(this.state.slctowner)
	criterias["postedby"]="1";
	else
	criterias["postedby"]="0";
	Usersession.setSearchopts(criterias);
	const homemain = document.getElementById('container') as HTMLElement;
      
	homemain.style.display = 'block';
	const Pdivc = document.getElementById('profilediv') as HTMLElement;
	Pdivc.style.display = 'none';
	//searchpostnow(criterias);
	//alert('txt');
	clearmain();
	//unmountComponentAtNode(homemain);
	const srch = <Search />;
	ReactDOM.render(srch,homemain);	
	//homemain.style.display = 'block';
	//alert(ppt);
      //this.getdata();		
	
	//alert(Pdivc.style.display);
	
	}
	
	toggelcriteria(e: any){
		
		

		const chkpvisible = this.state.togglecrit == false ? true: false;
		this.setState({ togglecrit: chkpvisible });
		const serarchoptiondv = document.getElementById('selectprotypediv') as HTMLElement;
		//const userprofile = document.getElementById('profilediv') as HTMLElement;
		if(chkpvisible == true){
			serarchoptiondv.style.display = 'block';
			//this.closecriteria(false);
		}
		else
		        serarchoptiondv.style.display = 'none';
		e.preventDefault()

	};
	closecriteria(opt: any){
		
		const serarchoptiondv = document.getElementById('selectprotypediv') as HTMLElement;
		if(opt){
		serarchoptiondv.style.display = 'none';
		this.setState({ togglecrit: false });
		}
		else{

		serarchoptiondv.style.display = 'block';
		}

	};
       opencloseproc(opt: any){
		
		const srchlocalitydv = document.getElementById('searchlocality') as HTMLElement;
		const prciconedv = document.getElementById('processicon') as HTMLElement;
		if(opt){
		srchlocalitydv.style.width = '94%';
		prciconedv.style.display = 'block';
		}
		else{
		srchlocalitydv.style.width = '100%';
		prciconedv.style.display = 'none';

		}

	};

	typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		if(eid == 'searchrent')
		{
		this.desecttypes();
		this.setState({ slctrent: true });
		this.selectedid('searchrent');
		this.setState({transcid:1});
		}
		else if(eid == 'searchsale'){
		this.desecttypes();
		this.setState({ slctsale: true });
		this.selectedid('searchsale');
		this.setState({transcid:2});
		}
		else if(eid == 'searchlease'){
		this.desecttypes();
		this.setState({ slctlease: true });
		this.selectedid('searchlease');
		this.setState({transcid:3});

		}
		else if(eid == 'searchservice'){
		this.desecttypes();
		this.setState({ slctlservice: true });
		this.selectedid('searchservice');
		this.setState({transcid:4});
		getmessage('No services Available Now','')
		}
		else if(eid == 'searchcity'){
		this.desectcitystate();
		this.setState({ slctcity: true });
		this.selectedid('searchcity');
		//const txtautofilcity = <AutocompleteInput />;
		
		//ReactDOM.render(txtautofilcity, document.getElementById('searchlocality'));

		}
		else if(eid == 'searchstate'){
		this.desectcitystate();
		this.setState({ slctstate: true });
		this.selectedid('searchstate');
		
		
		}
		else if(eid == 'searchhome'){
		this.desecthomeland();
		this.setState({ slcthome: true });
		this.setState({ slctland: false });
		this.selectedid('searchhome');

		}
		else if(eid == 'searchland'){
		this.desecthomeland();
		this.setState({ slctland: true });
		this.setState({ slcthome: false });
		this.selectedid('searchland');

		}

		else if(eid == 'searchowner'){
		this.desectowneragent();
		this.setState({ slctowner: true });
		this.selectedid('searchowner');
		}
		else if(eid == 'searchagent'){
		this.desectowneragent();
		this.setState({ slctagent: true });
		this.selectedid('searchagent');
		}

		e.preventDefault()

	};
        desectedid(id: any){
		
	   const selct = document.getElementById(id) as HTMLElement;
	   selct.style.backgroundColor = 'gray';

	}
	selectedid(id: any){
	
	   const selct = document.getElementById(id) as HTMLElement;
	   selct.style.backgroundColor = 'green';
	}
	
	desectcitystate(){

	this.setState({ slctcity: false });
	this.setState({ slctstate: false });
	this.desectedid('searchcity');
	this.desectedid('searchstate');

	}
	desecthomeland(){

	this.setState({ slcthome: false });
	this.setState({ slctland: false });
	this.desectedid('searchhome');
	this.desectedid('searchland');

	}
	desectowneragent(){

	this.setState({ slctowner: false });
	this.setState({ slctagent: false });
	this.desectedid('searchowner');
	this.desectedid('searchagent');

	}


	
	desecttypes(){
		
		this.setState({ slctrent: false });
		this.setState({ slctsale: false });

		
		this.setState({ slctlease: false });
		this.setState({ slctlservice: false });
	
		this.desectedid('searchrent');
		this.desectedid('searchsale');
		this.desectedid('searchlease');
		this.desectedid('searchservice');
		
		
		


	}
	
	componentDidMount() {
        //debugger;
     	       this.setState({ cities: incities });	
     	       //const txtautofilcity = <AutocompleteInput />;
		//const localitybyid = document.getElementById('searchlocality');
		//if(localitybyid)
		//ReactDOM.render(txtautofilcity, localitybyid);
	  // alert('ok');
		//const Pdivc = document.getElementById('profilediv') as HTMLElement;
		//Pdivc.style.display = 'block';
	
		this.opencloseproc(false);
    	}

	cityChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ cityid: typevalue });
        
        const localdatas = getpls(typevalue);
	
	if(localdatas == "NA"){ 
		
		this.getlocalitydata(typevalue);
	}
	else{
	const jsondata = JSON.parse(localdatas);
	 this.setState({ctlocality: jsondata});
	 
	}
	this.setState({ localityid: 0 });
        }
	localityChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ localityid: typevalue });
        }

   getlocalitydata(eid: any){
	 try {
          const arg = 'prd=0,' + eid;
        	this.opencloseproc(true);  
	axios.get(Configdata.srvurl + '/getcitylocalitis?' + arg)
            .then((response: any) => {
               
		const tdata = response.data;
            
		const d  = reducearray(tdata);
	        let drplocaldata = cnvrtdropdown(d,'pid','plname');
                const slctopt = [{ value: 0, label: 'Select Locality' }];
		
		this.setState({ctlocality: drplocaldata});
                const drpdata = JSON.stringify(drplocaldata);
		setpls(eid,drpdata);
		this.opencloseproc(false);
            })
            .catch((err: any) => {
              //  alert('Something went wrong');
                
            });

                
          }
        catch (e) {
          //  debugger;

        }

	
      	//e.preventDefault()


     }	

	render() {
		return (
		<form>
			
        	<div id="searchsidebardiv" className="sidebar-search" style={{width:'80vw',overflowX:'hidden',zIndex:'3000'}}>

		     <div className="search-title-bar">
                       	<div className="search-title">
			  Search
			</div>
			<a href="#" onClick={e => this.toggelcriteria(e)} title="Profile">
			<div className="search-title-toggle" id="togglesearch">
			  +
			</div>
			</a>
	   	     </div>

		    <div id="selectprotypediv" style={{width:'100%',overflowY:'scroll',height:'65vh',overflowX:'hidden',display:'block',zIndex:'3000'}}>		
		    <div style={{width:'100%',height:'auto'}}>
		     <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'100%',float:'left'}}>
			<div style={{paddingLeft:'15px',width:'100%',float:'left'}}>
			Select Search type
			</div>
		      </div>

		      <div className="sidebar-basic-info" style={{width:'100%',zIndex:'3000'}}>
			<a href="#" onClick={e => this.typeselect(e)} title="Rent">

                       	<div className="searchtype" id="searchrent" style={{backgroundColor:'green'}}>
			  Rent	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="Sale">

			<div className="searchtype" id="searchsale">
			  Sale	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="Lease">

			<div className="searchtype" id="searchlease">
			  Lease	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="Services">

			<div className="searchtype" id="searchservice">
			  Services	
			</div>
			</a>

		      </div>
		
		     <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'100%'}}>
			<div style={{paddingLeft:'15px',width:'100%',float:'left'}}>
			Select Location type
			</div>
		      </div>

		     <div className="sidebar-basic-info" style={{width:'100%',display:'none'}}>
			<a href="#" onClick={e => this.typeselect(e)} title="City">

                       	<div className="searchtype" id="searchcity" style={{backgroundColor:'green'}}>
			  City	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="State">

			<div className="searchtype" id="searchstate">
			  State	
			</div>
			</a>
			

		      </div>
		      <div style={{width:'95%',marginLeft:'1%'}}>
			<div className="searchtype" id="searchdist" style={{width:'90%',marginTop:'0px',height:'40px',color:'#000000'}}>
	 <Select placeholder="Select City"   onChange={e => this.cityChange(e) } id="ucity" options={this.state.cities} />

			</div>
			<div className="searchtype"  style={{width:'90%',marginTop:'0px',height:'40px',color:'#000000'}}>
			<div id="searchlocality" style={{width:'94%',marginTop:'0px',height:'40px',color:'#000000',float:'left'}}>
   <Select placeholder="Select Locality" isClearable={false}   onChange={e => this.localityChange(e) } id="drplocality" options={this.state.ctlocality} />
			</div>
			<div id="processicon" style={{width:'5%',marginTop:'0px',height:'40px',color:'#000000',float:'right'}}>
			<img style={{width:'100%',marginTop:'0px',height:'40px',color:'#000000'}} src={Process} />
			</div>
			</div>

		      </div>	
		  
		    <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'100%'}}>
			<div style={{paddingLeft:'15px',width:'100%',float:'left'}}>
			Property type
			</div>
		      </div>

		     <div className="sidebar-basic-info"  style={{width:'100%'}}>
			<a href="#" onClick={e => this.typeselect(e)} title="Rent">

                       	<div className="searchtype" id="searchhome" style={{backgroundColor:'green'}}>
			  Home	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="Sale">

			<div className="searchtype" id="searchland">
			  Land
			</div>
			</a>
			
		      </div>

		     <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'100%',display:'none'}}>
			<div style={{width:'50%'}}>
			<div className="searchtype" id="searchres" style={{width:'49%',backgroundColor:'#dedede',height:'2.6vh',float:'left'}}>
			<span className="resproperty">Residence</span>

			 <span className="resproperty-opt"><input type="checkbox"  id="chkoptresidence" style={{float:'left'}}  /></span>
			</div>

			<div className="searchtype" id="searchcommercial" style={{width:'49%',backgroundColor:'#dedede',height:'2.6vh',float:'right',position:'relative',top:'-35px',left:'40%'}}>
			<span className="resproperty">Commercial</span>

			 <span className="resproperty-opt"><input  type="checkbox" id="chkoptcommercial" style={{float:'left'}} /></span>
			</div>

			</div>
		     </div>
		    <div className="sidebar-basic-info"  style={{paddingBottom:'0px',width:'100%',display:'none'}}>
			<a href="#" onClick={e => this.typeselect(e)} title="Rent">

                       	<div className="searchtype" id="searchowner" style={{backgroundColor:'green'}}>
			  Owner	
			</div>
			</a>
			<a href="#" onClick={e => this.typeselect(e)} title="Sale">

			<div className="searchtype" id="searchagent">
			  Member
			</div>
			</a>
			
		      </div>

		     <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'94%',display:'none'}}>
			<div style={{paddingLeft:'15px',width:'100%',float:'left'}}>
			Property Price
			</div>
		      </div>

		     <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'95%',display:'none'}}>
			

                       	<div className="searchtype" id="searhdivcostfrom" style={{width:'90%'}}>
			  <input  type="text" placeholder="From" id="txtsearchcostfrom" style={{float:'left',width:'95%'}} />
			</div>
			

			<div className="searchtype" id="searchdivcostto" style={{width:'90%'}}>
			   <input  type="text" id="txtsearchcostto" placeholder="To" style={{float:'left',width:'95%'}} />

			</div>
			
			
		      </div>

		     	 <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'100%',display:'none'}}>
			<div style={{paddingLeft:'15px',width:'100%',float:'left'}}>
			Property Area
			</div>
		      </div>

		     <div className="sidebar-basic-info" style={{paddingBottom:'0px',width:'95%',display:'none'}}>
			

                       	<div className="searchtype" id="searhdivareafrom" style={{width:'90%'}}>
			  <input  type="text" placeholder="From" id="txtsearchareafrom" style={{float:'left',width:'95%'}} />
			</div>
			

			<div className="searchtype" id="searchdivareato" style={{width:'90%'}}>
			   <input  type="text" id="txtsearchareato" placeholder="To" style={{float:'left',width:'95%'}} />

			</div>
			
			
		      </div>
		      <div className="sidebar-basic-info" style={{paddingBottom:'10px',width:'90%'}}>
			<button id="submitsearch" onClick={e => this.searchproperty(e)} className="btnsearchopts" style={{float:'right',marginRight:'30px'}}>search</button>
		       </div>
		   </div>
	
		  </div>
		</div>

		

		</form>
		);
	}

	
}

export default Searchcriteria;
